<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
          <a-form-item label="所属省份" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-select
                    v-model="where.keyword.province"
                    placeholder="请选择省份"
                    v-decorator="[
                'province',
                {rules: [{ required: true, message: '请选择省份!' }],initialValue:where.keyword.province}
              ]"
            >
              <a-select-option
                      :value="info.name"
                      v-for="(info, index) in areaList"
                      :key="index"
              >{{info.name}}</a-select-option>
            </a-select>
          </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="状态">
              <a-select v-model="where.keyword.status" placeholder="请选择" allowClear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">启用</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-button type="primary" @click="searchList" v-btnlimit="'价格设置-搜索'">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
          </a-col>
        </a-row>
      
      </a-form>
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo(0,1)" type="primary" />
    </div>

    <div class="pxkeji-right-box">
     
      <pxkeji-btn
        name="批量启用"
        v-if="selectRows.length>0"
        v-btnlimit="'价格设置-批量启用'"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        v-btnlimit="'价格设置-批量禁用'"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />
      <pxkeji-btn name="批量设置价格" @click="batchDelete" v-if="selectRows.length>0" class="pxkeji_basic_btn" v-btnlimit="'价格设置-批量设置价格'"/>

      <a-alert type="info" showIcon style="margin-bottom:20px;">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="isDefault" slot-scope="isDefault">
          <a-tag v-if="isDefault==1" color="green">是</a-tag>
          <a-tag v-else  color="red">否</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="查看价格" @click="showPrice(action.id)" size="small" type="primary" v-btnlimit="'价格设置-查看价格'"/>
          <a-divider type="vertical" />
          <a-dropdown>
            <a-menu slot="overlay">
             
              <a-menu-item key="1">
                <pxkeji-btn
                  name="编辑"
                  v-btnlimit="'价格设置-编辑'"
                  @click="showInfo(action.id,0)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                  name="禁用"
                  v-btnlimit="'价格设置-启用禁用'"
                  @click="handleStatus(action.id,0)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  v-btnlimit="'价格设置-启用禁用'"
                  @click="handleStatus(action.id,1)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-else
                />
              </a-menu-item>
              <a-menu-item key="3"  v-if="action.isDefault!=1">
                <pxkeji-btn
                  name="删除"
                  v-btnlimit="'价格设置-删除'"
                  @click="delInfo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'价格设置-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <priceSettingInfo @callbackMethod="save" :id="addedit.id" />
    </a-modal>
    <a-modal
            v-model="priceShow.visible"
            width="1000px"
            :footer="false"
            destroyOnClose
            :maskClosable="false"
    >
      <coursePriceList  :id="priceShow.id" />
    </a-modal>
  </div>
</template>
<script>
var that;
import priceSettingInfo from "./priceSettingInfo.vue"; //新增编辑
import coursePriceList from "./coursePriceList.vue";
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "编号"
  },
  {
    dataIndex: "province",
    key: "province",
    align: "center",
    title: "地区"
  },
  {
    dataIndex: "isDefault",
    key: "isDefault",
    align: "center",
    title: "是否默认",
    scopedSlots: { customRender: "isDefault" }
  },
  {
    dataIndex: "createUser",
    key: "createUser",
    align: "center",
    title: "创建人"
  },
  {
    dataIndex: "createTime",
    key: "createTime",
    align: "center",
    title: "创建时间",
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "left",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "priceSettingList",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      priceShow:{
        id:0,
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          province: "",
          city: "",
          area: "",
          status: "",

        },
      },
      areas: [],
      areaList: [],
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框

    };
  },
  components: {
    priceSettingInfo,
    coursePriceList
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
      this.getArea();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    getArea() {
      this.areaList = this.$api.city.city;
    },
    areaChange(value) {
      this.where.keyword.province = value[0];
      this.where.keyword.city = value[1];
      this.where.keyword.area = value[2];
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.courseprice
        .getCourseSettingPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.province,
          this.where.keyword.city,
          this.where.keyword.area,
          this.where.keyword.status
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    showPrice(id){
      this.priceShow.id=id;
      this.priceShow.visible=true;
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    /*编辑查看 */
    showInfo(id, type) {
      //打开弹出框
      this.addedit.visible = true;
      this.addedit.title = type == 1 ? "添加" : "编辑";
      this.addedit.id = id;
      this.addedit.type = type;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /**单个启用禁用 */
    handleStatus(ids, status) {
      if (status == 0) {
        this.$confirm({
          title: "您确定要执行禁用的操作吗?",
          okText: "确定",
          okType: "danger",
          cancelText: "我再想想",
          onOk() {
            that.handleProhibit(ids, 0);
          },
          onCancel() {}
        });
      } else {
        that.handleProhibit(ids, 1);
      }
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.courseprice
        .updateStatus(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.courseprice
            .deleteById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /** 批量删除 */
    batchDelete() {
      this.$confirm({
        title: "您确定要执行批量删除的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.courseprice
            .deleteById(that.selectRows.join(","))
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /**编辑 */
    edit() {
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

